import api from "./index"
import { IAddEmployeeBodyParams } from "types/employee"
import { IGetEmployeesQueryParams, IEmployee } from "api/querries/useGetEmployees"

export const getEmployees = (params: IGetEmployeesQueryParams) => {

  const { sortBy, pageSize, pageIndex, carWashIds } = params

  let query = `sortBy=${sortBy}&pageSize=${pageSize}&pageIndex=${pageIndex}`

  if(carWashIds !== undefined && carWashIds.length > 0) {
    carWashIds.forEach(( id: number, i: number ) => {
      query += `&carWashIds[${i}]=${id}`
    })
  }

  return api.get(`/employees/getEmployees?${query}`)

}

export const getEmployeeRoles = () =>
  api.get("/employees/getRoles")

export const addEmployee = (data: IAddEmployeeBodyParams) =>
  api.post("/employees/addEmployee", data)

export const updateEmployee = (data: IEmployee) =>
  api.put("/employees/updateEmployee", data)
  
export const deleteEmployee = (employeeId: number) =>
  api.delete(`/employees/deleteEmployee/${employeeId}`)

export default { getEmployees, getEmployeeRoles, addEmployee, updateEmployee, deleteEmployee }
